
  window.WarmiaConfig = window.WarmiaConfig || {};
  window.WarmiaConfig["warmia"] = {
    productHandle: "device-belt-reliefer",
    mainVariant: 55023867461931,
    priceBase: "399 د.م",
    priceDeal: "249 د.م",
    upsellHandle: "device-belt-reliefer",
    upsellPrice: 179,
    addons: {
      "smart-scalp-massager": { name: "جهاز تدليك فروة الرأس الكهربائي", price: 70 },
      "face-massager-cream": { name: "جهاز تدليك الوجه مع الكريم", price: 200 }
    },
    stockMax: 52,
    pixelId: "",
    autoRedirect: true,
    gifts: [
      { name: "سيروم فيتامين C", handle: "gift-serum-vitamin-c", variantId: 55660504777003, value: 129, img: "https://cdn.shopify.com/s/files/1/1014/4441/9883/files/gift-serum-vitamin-c.png" },
      { name: "زيت أركان أصلي 100%", handle: "gift-argan-oil", variantId: 55660504908075, value: 149, img: "https://cdn.shopify.com/s/files/1/1014/4441/9883/files/gift-argan-oil.png" },
      { name: "ماء الورد البلدي", handle: "gift-rose-water", variantId: 55660505268523, value: 79, img: "https://cdn.shopify.com/s/files/1/1014/4441/9883/files/gift-rose-water.png" },
      { name: "غاسول مغربي", handle: "gift-rhassoul", variantId: 55660505432363, value: 89, img: "https://cdn.shopify.com/s/files/1/1014/4441/9883/files/gift-rhassoul.png" },
      { name: "قناع العين الدافئ", handle: "gift-heated-eye-mask", variantId: 55660505596203, value: 169, img: "https://cdn.shopify.com/s/files/1/1014/4441/9883/files/gift-heated-eye-mask.png" },
      { name: "زيت المساج بالأعشاب", handle: "gift-massage-oil", variantId: 55660505858347, value: 119, img: "https://cdn.shopify.com/s/files/1/1014/4441/9883/files/gift-massage-oil.png" },
      { name: "كريم زبدة الشيا", handle: "gift-shea-cream", variantId: 55660506022187, value: 139, img: "https://cdn.shopify.com/s/files/1/1014/4441/9883/files/gift-shea-cream.png" },
      { name: "سيروم العناية", handle: "gift-luxury-serum", variantId: 55660506251563, value: 199, img: "" }
    ]
  };



document.documentElement.classList.add('js');
var warmiaStore={get:function(k){try{return localStorage.getItem(k)}catch(e){return null}},set:function(k,v){try{localStorage.setItem(k,v)}catch(e){}}};

function warmiaPhURI(e,t){var s='<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#FFE3EC"/><stop offset="1" stop-color="#FBC9DA"/></linearGradient></defs><rect width="600" height="600" fill="url(#g)"/><text x="300" y="290" font-size="170" text-anchor="middle" dominant-baseline="middle">'+e+'</text><text x="300" y="430" font-size="36" fill="#937082" text-anchor="middle" font-family="Tahoma">'+t+'</text></svg>';return 'data:image/svg+xml;charset=utf-8,'+encodeURIComponent(s);}
window.warmiaImgFail=function(im){if(im.dataset.fb){var f=im.dataset.fb;im.dataset.fb='';im.src=f;}else{im.onerror=null;im.src=warmiaPhURI(im.dataset.ph||'🎀',im.dataset.pht||'Warmia');}};

function warmiaInitSection(root){
  var sid=root.getAttribute('data-warmia-id');
  var cfg=(window.WarmiaConfig&&window.WarmiaConfig[sid])||{};
  var PRODUCT_HANDLE=cfg.productHandle||'smart-warm-palace-belt';
  var PRICE_BASE=cfg.priceBase||'', PRICE_DEAL=cfg.priceDeal||'';
  var UPSELL_HANDLE=cfg.upsellHandle||'',UPSELL_PRICE=parseInt(cfg.upsellPrice)||179;
  var STOCK_MAX=parseInt(cfg.stockMax)||52;
  var PIXEL_ID=(cfg.pixelId||'').trim();
  var AUTO_REDIRECT=cfg.autoRedirect!==false;
  var GIFTS=cfg.gifts||[];
  var WIN_INDEX=Math.max(0,GIFTS.length-1); /* the gold segment = grand gift */

  var stockKey='warmia_stock_'+sid, unlockedKey='warmia_unlocked_'+sid, deadlineKey='warmia_deadline_'+sid;
  var stock=parseInt(warmiaStore.get(stockKey))||STOCK_MAX;
  var unlocked=warmiaStore.get(unlockedKey)==='1';
  var deadline=parseInt(warmiaStore.get(deadlineKey))||0;
  var spun=false,VARIANT_ID=parseInt(cfg.mainVariant)||null,slot='مساءً خلال 24–48 ساعة',pledged=false;
  var PRODUCT_TITLE='',ORDER_VALUE=0,bundleQty=1,bundlePrice=249,bundleAddon='',bundleAddonVariant=0,bundleAddonName='',upsellSelected=false;

  /* ---------- Ads pixels: Meta + TikTok + Snapchat + Google ---------- */
  var TK=window.WarmiaTrack||{};
  var META_ID=String(TK.meta||PIXEL_ID||'').replace(/\D/g,'');
  var TT_ID=String(TK.tiktok||'').trim().replace(/[^A-Za-z0-9]/g,'');
  var SNAP_ID=String(TK.snap||'').trim().replace(/[^A-Za-z0-9\-]/g,'');
  var GT_ID=String(TK.gtag||'').trim().replace(/[^A-Za-z0-9\-]/g,'');
  var GADS_PURCHASE=String(TK.gadsPurchase||TK.gadsLabel||'').trim();
  var GADS_CHECKOUT=String(TK.gadsCheckout||'').trim();
  var GADS_LEAD=String(TK.gadsLead||'').trim();
  var VISITOR_COUNTRY=String(TK.country||'').toUpperCase();
  var MODE=(TK.mode==='lead'||TK.mode==='both')?TK.mode:'purchase';
  function addScript(src){var s=document.createElement('script');s.async=true;s.src=src;document.head.appendChild(s);}
  var CONSENT_COUNTRIES=['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','IS','LI','NO','GB','CH','CA'];
  var googlePermission;
  function canTrackGoogle(){
    if(googlePermission)return googlePermission;
    googlePermission=new Promise(function(resolve){
      if(VISITOR_COUNTRY){resolve(CONSENT_COUNTRIES.indexOf(VISITOR_COUNTRY)<0);return;}
      var ctl=('AbortController' in window)?new AbortController():null;
      var tm=setTimeout(function(){if(ctl)ctl.abort();resolve(false);},2000);
      fetch('/cdn-cgi/trace',{signal:ctl?ctl.signal:undefined}).then(function(r){if(!r.ok)throw new Error('geo');return r.text();}).then(function(t){clearTimeout(tm);var m=t.match(/^loc=([A-Z0-9]{2})$/m);resolve(!!m&&m[1]!=='XX'&&m[1]!=='T1'&&CONSENT_COUNTRIES.indexOf(m[1])<0);}).catch(function(){clearTimeout(tm);resolve(false);});
    });
    return googlePermission;
  }
  function initGoogle(){return canTrackGoogle().then(function(allowed){
    if(!allowed||!GT_ID)return false;
    window.dataLayer=window.dataLayer||[];
    if(!window.gtag)window.gtag=function(){window.dataLayer.push(arguments)};
    if(!document.querySelector('script[data-warmia-google],script[src*="googletagmanager.com/gtag/js"]')){var s=document.createElement('script');s.async=true;s.src='https://www.googletagmanager.com/gtag/js?id='+GT_ID;s.setAttribute('data-warmia-google','');document.head.appendChild(s);window.gtag('js',new Date());}
    if(!window.__warmiaGoogleConfigured){window.__warmiaGoogleConfigured=1;window.gtag('config',GT_ID);}
    return true;
  });}
  function pxInit(){
    if(window.__warmiaPx)return;window.__warmiaPx=1;
    try{if(META_ID){
      if(!window.fbq){var n=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};n.push=n;n.loaded=true;n.version='2.0';n.queue=[];window.fbq=n;if(!window._fbq)window._fbq=n;addScript('https://connect.facebook.net/en_US/fbevents.js');}
      window.fbq('init',META_ID);
    }}catch(e){}
    try{if(TT_ID&&!window.ttq){
      var w=window,t='ttq',q=w[t]=w[t]||[];q.methods=['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie','holdConsent','revokeConsent','grantConsent'];
      q.setAndDefer=function(o,m){o[m]=function(){o.push([m].concat(Array.prototype.slice.call(arguments,0)))}};
      for(var i=0;i<q.methods.length;i++)q.setAndDefer(q,q.methods[i]);
      q.instance=function(id){for(var o=q._i[id]||[],j=0;j<q.methods.length;j++)q.setAndDefer(o,q.methods[j]);return o};
      q.load=function(id){var u='https://analytics.tiktok.com/i18n/pixel/events.js';q._i=q._i||{};q._i[id]=[];q._i[id]._u=u;q._t=q._t||{};q._t[id]=+new Date;q._o=q._o||{};addScript(u+'?sdkid='+id+'&lib='+t);};
      q.load(TT_ID);
    }}catch(e){}
    try{if(SNAP_ID&&!window.snaptr){var a=window.snaptr=function(){a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};a.queue=[];addScript('https://sc-static.net/scevent.min.js');window.snaptr('init',SNAP_ID,{});}}catch(e){}
    try{initGoogle();}catch(e){}
    track('PageView',{});
  }
  function newEventId(name){return 'wm-'+name+'-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8);}
  /* One call -> every connected platform, each with its own standard event name */
  var MAP={
    PageView:        {fb:'PageView',        tt:null,               sc:'PAGE_VIEW',     g:'page_view'},
    ViewContent:     {fb:'ViewContent',     tt:'ViewContent',      sc:'VIEW_CONTENT',  g:'view_item'},
    InitiateCheckout:{fb:'InitiateCheckout',tt:'InitiateCheckout', sc:'START_CHECKOUT',g:'begin_checkout'},
    Purchase:        {fb:'Purchase',        tt:'CompletePayment',  sc:'PURCHASE',      g:'purchase'},
    Lead:            {fb:'Lead',            tt:'SubmitForm',       sc:'SIGN_UP',       g:'generate_lead'}
  };
  function track(name,p,eventId){
    var m=MAP[name];if(!m)return;p=p||{};eventId=eventId||newEventId(name);
    var val=Number(p.value)||0,cur=p.currency||'MAD',ids=p.content_ids||[PRODUCT_HANDLE];
    try{if(META_ID&&window.fbq){var fp={};for(var k in p)fp[k]=p[k];window.fbq('track',m.fb,fp,{eventID:eventId});}}catch(e){}
    try{if(TT_ID&&window.ttq){if(name==='PageView')window.ttq.page();else window.ttq.track(m.tt,{value:val,currency:cur,content_type:'product',contents:[{content_id:String(ids[0]),content_name:p.content_name||'Warmia',quantity:p.num_items||1,price:val}]},{event_id:eventId});}}catch(e){}
    try{if(SNAP_ID&&window.snaptr){var sp={client_dedup_id:eventId};if(val){sp.price=val;sp.currency=cur;}sp.item_ids=ids.map(String);if(p.num_items)sp.number_items=p.num_items;if(p.order_id)sp.transaction_id=p.order_id;window.snaptr('track',m.sc,sp);}}catch(e){}
    try{if(GT_ID&&name!=='PageView')initGoogle().then(function(allowed){if(!allowed||!window.gtag)return;var gp={value:val,currency:cur,items:[{item_id:String(ids[0]),item_name:p.content_name||'Warmia',quantity:p.num_items||1,price:val}]};if(p.order_id)gp.transaction_id=p.order_id;window.gtag('event',m.g,gp);
      if(name==='InitiateCheckout'&&GADS_CHECKOUT)window.gtag('event','conversion',{send_to:GT_ID+'/'+GADS_CHECKOUT,value:val,currency:cur});
      if(name==='Lead'&&GADS_LEAD)window.gtag('event','conversion',{send_to:GT_ID+'/'+GADS_LEAD,value:val,currency:cur,transaction_id:p.order_id||eventId});
      if(name==='Purchase'&&GADS_PURCHASE)window.gtag('event','conversion',{send_to:GT_ID+'/'+GADS_PURCHASE,value:val,currency:cur,transaction_id:p.order_id||eventId});
    });}catch(e){}
    try{(window.dataLayer=window.dataLayer||[]).push({event:'warmia_'+name,event_id:eventId,value:val,currency:cur,order_id:p.order_id||undefined});}catch(e){}
  }
  function px(name,params){track(name,params);} /* back-compat */
  pxInit();
  function fallbackValue(){var d=parseInt((PRICE_DEAL||'').replace(/[^\d]/g,''))||0;return d;}
  function productValue(){return bundlePrice+(upsellSelected?UPSELL_PRICE:0);}

  /* ---------- Live product data (relies on the actual Shopify product) ---------- */
  fetch('/products/'+PRODUCT_HANDLE+'.js').then(function(r){return r.json()}).then(function(p){
    if(p&&p.variants&&p.variants[0])VARIANT_ID=p.variants[0].id;
    if(p&&p.title){PRODUCT_TITLE=p.title;ORDER_VALUE=Math.round(p.price)/100;}
    var t=root.querySelector('.cf-title');if(t&&PRODUCT_TITLE)t.textContent=PRODUCT_TITLE;
    px('ViewContent',{content_name:PRODUCT_TITLE,content_ids:[PRODUCT_HANDLE],content_type:'product',value:productValue(),currency:'MAD'});
  }).catch(function(){});

  var mq=root.querySelector('.marquee-track');if(mq)mq.innerHTML+=mq.innerHTML;

  window.warmiaSetImg=function(t,rid){if(rid!==sid)return;var g=root.querySelector('.g-main');if(g)g.src=t.src;var th=root.querySelectorAll('.g-thumbs img');for(var i=0;i<th.length;i++)th[i].classList.remove('on');t.classList.add('on');};
  window.warmiaSelSlot=function(el,v){slot=v;var s=root.querySelectorAll('.slot');for(var i=0;i<s.length;i++)s[i].classList.remove('on');el.classList.add('on');};
  window.warmiaTogglePledge=function(rid){if(rid!==sid)return;pledged=!pledged;var pl=root.querySelector('.pledge');if(pl)pl.classList.toggle('on',pledged);};
  window.warmiaSelectBundle=function(el,rid){
    if(rid!==sid)return;
    var all=root.querySelectorAll('.bundle');for(var i=0;i<all.length;i++)all[i].classList.remove('on');
    el.classList.add('on');bundlePrice=parseInt(el.dataset.price)||249;bundleAddon=el.dataset.addon||'';bundleAddonVariant=parseInt(el.dataset.addonVariant)||0;bundleAddonName=el.dataset.addonName||'';
    var labels=root.querySelectorAll('.bundle-select');for(var j=0;j<labels.length;j++)labels[j].textContent='اختاري هاد العرض';
    var selectedLabel=el.querySelector('.bundle-select');if(selectedLabel)selectedLabel.textContent='مختار دابا';
    priceUI();
  };
  var upsellEl=root.querySelector('.upsell');
  function toggleUpsell(){upsellSelected=!upsellSelected;if(upsellEl){upsellEl.classList.toggle('on',upsellSelected);upsellEl.setAttribute('aria-checked',String(upsellSelected));}priceUI();}
  if(upsellEl){upsellEl.addEventListener('click',toggleUpsell);upsellEl.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();toggleUpsell();}});}


  function priceUI(){
    var total=bundlePrice+(upsellSelected?UPSELL_PRICE:0),now=total+' د.م';
    var pn=root.querySelector('.price-now');if(pn)pn.textContent=now;
    var c=root.querySelectorAll('.cp');for(var i=0;i<c.length;i++)c[i].textContent=now;
    var ho=root.querySelector('.price-old');if(ho)ho.classList.add('on');
    var os=root.querySelector('[id^="oldS-"]');if(os)os.classList.add('on');
    var bundleLabel=bundleAddonName?('Warmia + '+bundleAddonName):'Warmia وحدو';
    var summaryLabel=root.querySelector('.cf-bundle-label');if(summaryLabel)summaryLabel.textContent=bundleLabel+(upsellSelected?' + Warmia ثاني':'');
    var activeBundle=root.querySelector('.bundle.on');
    var addonImg=root.querySelector('.cf-addon-img'),plus=root.querySelector('.cf-plus');
    var addonSrc=activeBundle?activeBundle.dataset.addonImage||'':'';
    if(addonImg){addonImg.classList.toggle('on',!!addonSrc);if(addonSrc)addonImg.src=addonSrc;}
    if(plus)plus.classList.toggle('on',!!addonSrc);
    if(unlocked){
      var sc=root.querySelector('.save-chip');if(sc)sc.style.display='none';
      var cc=root.querySelector('.code-chip');if(cc)cc.classList.add('on');
      var ob=root.querySelector('.offerbar-js');if(ob)ob.classList.add('on');
      var gw=root.querySelector('.cf-gift');if(gw)gw.hidden=false;
    }
  }
  priceUI();

  function tick(){
    var e=root.querySelectorAll('[data-timer]');var l=30*60;
    if(unlocked&&deadline)l=Math.max(0,Math.floor((deadline-Date.now())/1000));
    var m=('0'+Math.floor(l/60)).slice(-2),s=('0'+(l%60)).slice(-2);
    for(var i=0;i<e.length;i++){e[i].textContent=m+':'+s;e[i].classList.toggle('hot',l<300&&l>0);}
  }
  setInterval(tick,1000);tick();

  function stockUI(p){
    var a=root.querySelectorAll('[data-stock]');for(var i=0;i<a.length;i++)a[i].textContent=stock;
    var b=root.querySelectorAll('[data-stockbar]');for(var i=0;i<b.length;i++)b[i].style.width=Math.round(stock/STOCK_MAX*100)+'%';
    if(p){var x=root.querySelector('.stock-box');if(x){x.classList.remove('pulse');void x.offsetWidth;x.classList.add('pulse');}}
  }
  stockUI(false);

  var ordEl=root.querySelector('[id^="ordToday-"]');var ord=37;
  setInterval(function(){if(ord<52&&ordEl){ord++;ordEl.textContent=ord;}},45000);

  var modal=root.querySelector('.modal-js'), reopen=root.querySelector('.reopen-js');
  window.warmiaOpenModal=function(rid){if(rid!==sid)return;if(modal)modal.classList.add('on');if(reopen)reopen.classList.remove('on');};
  window.warmiaCloseModal=function(w,rid){if(rid!==sid)return;if(modal)modal.classList.remove('on');if(!w&&!spun&&reopen)reopen.classList.add('on');};
  setTimeout(function(){if(!unlocked)window.warmiaOpenModal(sid);},900);
  setTimeout(function(){if(!unlocked)window.warmiaOpenModal(sid);},2600);

  /* ---------- Gift wheel (free gifts, always lands on the grand gift) ---------- */
  window.warmiaSpin=function(rid){
    if(rid!==sid||spun)return;spun=true;
    var b=root.querySelector('.spin-btn');if(b){b.disabled=true;b.textContent='جاري الدوران… ✨';}
    var w=root.querySelector('.wheel-el');
    var j=Math.random()*22-11;
    /* gold segment center = 337.5deg */
    if(w)w.style.transform='rotate('+(360*6+(360-337.5)+j)+'deg)';
    setTimeout(function(){
      unlocked=true;deadline=Date.now()+30*60*1000;
      warmiaStore.set(unlockedKey,'1');warmiaStore.set(deadlineKey,String(deadline));
      var wc=root.querySelector('.wheel-card');if(wc)wc.classList.add('won');
      var g=GIFTS[WIN_INDEX]||null;
      if(g&&g.img){var pi=root.querySelector('.prize-img');if(pi)pi.src=g.img;var pv=root.querySelector('[id^="prizeValue-"]');if(pv)pv.textContent=g.value+' د.م';}
      warmiaConfetti();priceUI();tick();
      warmiaStartPopups();
    },5100);
  };

  function warmiaConfetti(){
    var c=root.querySelector('.confetti');if(!c)return;
    var col=['#E75A8C','#F6A8C3','#FBC9DA','#E8B44C','#fff','#D93D77'];
    for(var i=0;i<90;i++){var p=document.createElement('i');p.className='cf';p.style.left=Math.random()*100+'%';p.style.background=col[i%6];p.style.setProperty('--d',(1.6+Math.random()*1.8)+'s');p.style.setProperty('--r',(Math.random()*720-360)+'deg');p.style.animationDelay=(Math.random()*.7)+'s';c.appendChild(p);}
    setTimeout(function(){c.innerHTML='';},4200);
  }

  var popupsStarted=false;
  function warmiaStartPopups(){if(popupsStarted)return;popupsStarted=true;setTimeout(popup,1500);}
  setTimeout(function(){if(!popupsStarted)warmiaStartPopups();},12000);
  var buyers=[['سلمى','الدار البيضاء'],['خديجة','مراكش'],['مريم','الرباط'],['هاجر','فاس'],['زينب','طنجة'],['إيمان','أكادير'],['أسماء','مكناس'],['شيماء','وجدة'],['لبنى','القنيطرة'],['رزان','تطوان'],['سعاد','سلا'],['حنان','الجديدة']];
  var ago=['الآن','قبل دقيقة','قبل دقيقتين','قبل 4 دقائق'];
  function popup(){
    var toastWrap=root.querySelector('.toasts-js');if(!toastWrap)return;
    var b=buyers[Math.floor(Math.random()*buyers.length)];
    var t=document.createElement('div');t.className='toast';
    var imgSrc=(root.querySelector('.g-main')||{}).src||'';
    t.innerHTML='<img loading="eager" src="'+imgSrc+'" onerror="this.onerror=null;this.src=warmiaPhURI(\'🎀\',\'Warmia\')"><div><b>'+b[0]+' من '+b[1]+'</b><small>طلبت المنتج</small><span class="vf">طلب مؤكد · '+ago[Math.floor(Math.random()*ago.length)]+'</span></div>';
    toastWrap.appendChild(t);
    requestAnimationFrame(function(){t.classList.add('on');});
    setTimeout(function(){
      t.classList.remove('on');
      setTimeout(function(){if(t.parentNode)t.parentNode.removeChild(t);},600);
      if(stock>6){stock--;warmiaStore.set(stockKey,String(stock));stockUI(true);}
    },4200);
    setTimeout(popup,15000);
  }

  /* ---------- Embedded COD form ---------- */
  var ORDER_API='https://swift-shopify-sell.lovable.app/api/public/warmia-order';
  var ORDER_SERVICE_VERSION='warmia-order-v2';
  var icFired=false;
  function fireInitiateCheckout(){
    if(icFired)return;icFired=true;
    px('InitiateCheckout',{content_name:PRODUCT_TITLE||'Warmia',content_ids:[PRODUCT_HANDLE],content_type:'product',value:productValue(),currency:'MAD',num_items:1});
  }

  window.warmiaCheckout=function(rid){
    if(rid!==sid)return;
    var f=root.querySelector('.cod-form');
    if(f&&f.scrollIntoView){f.scrollIntoView({behavior:'smooth',block:'center'});
      setTimeout(function(){f.classList.remove('pulse-form');void f.offsetWidth;f.classList.add('pulse-form');var n=root.querySelector('.cod-name');if(n){try{n.focus({preventScroll:true});}catch(e){n.focus();}}},700);
    }
  };

  function addVariant(id,props,qty){
    var body={items:[{id:id,quantity:qty||1}]};
    if(props)body.items[0].properties=props;
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).then(function(){return true}).catch(function(){return false});
  }
  function addRef(id,handle,props,qty){
    if(id)return addVariant(id,props,qty);
    return addByHandle(handle,props,qty);
  }
  function addByHandle(handle,props,qty){
    if(!handle)return Promise.resolve(false);
    return fetch('/products/'+handle+'.js').then(function(r){return r.json()}).then(function(p){
      if(!p||!p.variants||!p.variants[0])return false;
      var body={items:[{id:p.variants[0].id,quantity:qty||1}]};
      if(props)body.items[0].properties=props;
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).then(function(){return true}).catch(function(){return false});
    }).catch(function(){return false});
  }
  function saveCartAttrs(attrs){
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attrs})}).catch(function(){});
  }

  var form=root.querySelector('.cf-fields');
  if(form){
    var nameEl=root.querySelector('.cod-name'),cityEl=root.querySelector('.cod-city'),phoneEl=root.querySelector('.cod-phone'),addrEl=root.querySelector('.cod-address'),btn=root.querySelector('.cod-btn');
    [nameEl,phoneEl].forEach(function(el){if(el)el.addEventListener('input',function(){if((el.value||'').replace(/\s/g,'').length>=2)fireInitiateCheckout();},{passive:true});});
    if(cityEl)cityEl.addEventListener('change',function(){if(cityEl.value)fireInitiateCheckout();},{passive:true});
    if(addrEl)addrEl.addEventListener('input',function(){addrEl.classList.remove('bad');var e=root.querySelector('.err-address');if(e)e.classList.remove('on');});
    [nameEl,phoneEl].forEach(function(el){if(el)el.addEventListener('input',function(){el.classList.remove('bad');var e=root.querySelector('.err-'+((el===nameEl)?'name':'phone'));if(e)e.classList.remove('on');});});

    function normPhone(v){
      v=(v||'').replace(/[\s\-().]/g,'');
      if(v.indexOf('+212')===0)v=v.slice(4);else if(v.indexOf('00212')===0)v=v.slice(5);else if(v.indexOf('212')===0)v=v.slice(3);
      if(/^[5-7]/.test(v)&&v.length===9)v='0'+v;
      return v;
    }
    function showErr(el,cls,msg){var e=root.querySelector(cls);if(e){e.textContent=msg;e.classList.add('on');}if(el)el.classList.add('bad');}
    function toastErr(msg){var t=root.querySelector('.toasts-js');if(!t)return;var d=document.createElement('div');d.className='toast';d.style.pointerEvents='auto';d.innerHTML='<div><b>'+msg+'</b></div>';t.appendChild(d);requestAnimationFrame(function(){d.classList.add('on');});setTimeout(function(){d.classList.remove('on');setTimeout(function(){if(d.parentNode)d.parentNode.removeChild(d);},600);},3000);}

    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(btn&&btn.disabled)return;
      var name=(nameEl&&nameEl.value||'').trim();
      var city=(cityEl&&cityEl.value||'').trim();
      var address=(addrEl&&addrEl.value||'').trim();
      var phone=normPhone(phoneEl&&phoneEl.value||'');
      var ok=true;
      if(name.length<3){showErr(nameEl,'.err-name','المرجو كتابة الاسم الكامل');ok=false;}
      if(!city){showErr(cityEl,'.err-city','المرجو اختيار المدينة');ok=false;}
      if(address.length<3){showErr(addrEl,'.err-address','المرجو كتابة العنوان أو الحي');ok=false;}
      if(!/^0[5-7]\d{8}$/.test(phone)){showErr(phoneEl,'.err-phone','رقم غير صحيح — مثال: 0612345678');ok=false;}
      if(!ok){toastErr('⚠️ المرجو إكمال المعلومات الناقصة');return;}

      fireInitiateCheckout();

      var giftObj=unlocked?(GIFTS[WIN_INDEX]||null):null;
      var giftAdded=!!(giftObj&&giftObj.handle);
      var convValue=productValue();
      var convItems=(upsellSelected?2:1)+(bundleAddon?1:0)+(giftAdded?1:0);

      if(btn){btn.disabled=true;btn.textContent='⏳ جاري تسجيل الطلب…';}

      var mainQty=upsellSelected?2:1;
      var bundleLabel=bundleAddonName?('Warmia + '+bundleAddonName):'Warmia وحدو';
      var slotEl=root.querySelector('.cod-slot');
      var slot=(slotEl&&slotEl.value)||'';
      var pledgedEl=root.querySelector('.cod-pledge');
      var pledged=!!(pledgedEl&&pledgedEl.checked);

      var lines=[{variantId:VARIANT_ID,quantity:mainQty,properties:{'العرض المختار':bundleLabel}}];
      if(bundleAddonVariant){lines.push({variantId:bundleAddonVariant,quantity:1,properties:{'ضمن العرض':bundleLabel}});}
      if(giftObj&&giftObj.variantId){lines.push({variantId:giftObj.variantId,quantity:1,properties:{'هدية مجانية':'نعم 🎁'}});}

      var payload=JSON.stringify({
        name:name,phone:phone,city:city,address:address,slot:slot,total:productValue(),
        note:'العرض: '+bundleLabel+' — '+bundlePrice+' د.م'+(upsellSelected?' + Warmia ثاني 179 د.م':'')+(pledged?' — عهد الاستلام: نعم':'')+(giftObj?(' — هدية العجلة: '+giftObj.name):''),
        lines:lines
      });
      function sendOrder(tries){
        var ctl=('AbortController' in window)?new AbortController():null;
        var tm=setTimeout(function(){if(ctl)ctl.abort();},20000);
        return fetch(ORDER_API,{method:'POST',mode:'cors',headers:{'Content-Type':'application/json'},body:payload,signal:ctl?ctl.signal:undefined})
          .then(function(r){clearTimeout(tm);return r.json().catch(function(){return {ok:false};}).then(function(d){d=d||{};if(r.status===400)d.fatal=true;if(d.ok&&d.serviceVersion!==ORDER_SERVICE_VERSION){d.ok=false;d.stale=true;}return d;});})
          .then(function(d){if(d.ok)return d;if(d.fatal)throw d;throw new Error('retry');})
          .catch(function(e){clearTimeout(tm);if(e&&e.fatal)throw e;if(tries>1){return new Promise(function(ok){setTimeout(ok,1500);}).then(function(){return sendOrder(tries-1);});}throw e;});
      }
      sendOrder(3).then(function(res){
        if(!res||!res.ok)throw new Error('order_failed');
        /* Conversion fires ONLY after Shopify confirmed the order — once per order, never on errors/retries */
        try{
          var oid=String(res.order||'').replace('#','')||newEventId('order');
          var sentKey='warmia_conv_'+oid;
          if(!warmiaStore.get(sentKey)){
            warmiaStore.set(sentKey,'1');
            var cp={value:convValue,currency:'MAD',content_ids:[PRODUCT_HANDLE],content_type:'product',num_items:convItems,content_name:PRODUCT_TITLE||'Warmia',order_id:oid};
            if(MODE!=='lead')track('Purchase',cp,'wm-purchase-'+oid);
            if(MODE!=='purchase')track('Lead',cp,'wm-lead-'+oid);
          }
        }catch(_e){}
        try{sessionStorage.setItem('warmia_thanks',JSON.stringify({order:res.order||'',name:name,city:city,phone:phone,price:productValue(),gift:giftObj?giftObj.name:''}));}catch(_e){}
        window.location.assign('/pages/thank-you-page');
      }).catch(function(e){
        if(btn){btn.disabled=false;btn.textContent='✅ تأكيد الطلب — الدفع عند الاستلام';}
        toastErr(e&&e.fatal?'المرجو التأكد من المعلومات':'تعذر تأكيد الطلب دابا… المرجو إعادة المحاولة');
      });
    });
  }

  (function(){
    var done=root.querySelector('.cod-done');if(!done)return;
    if(!done.querySelector('.cd-x')){var x=document.createElement('button');x.type='button';x.className='cd-x';x.setAttribute('aria-label','إغلاق');x.textContent='✕';x.style.cssText='position:absolute;top:12px;left:12px;width:38px;height:38px;border-radius:50%;border:0;background:rgba(0,0,0,.08);font-size:18px;cursor:pointer;z-index:5';var box=done.firstElementChild||done;if(getComputedStyle(box).position==='static')box.style.position='relative';box.appendChild(x);}
    function closeDone(){done.classList.remove('on');document.body.style.overflow='';var f=root.querySelector('form');if(f&&f.reset)f.reset();var b=root.querySelector('.cod-submit,button[type=submit]');if(b){b.disabled=false;b.textContent='✅ تأكيد الطلب — الدفع عند الاستلام';}}
    done.addEventListener('click',function(e){if(e.target===done||e.target.closest('.cd-x')||e.target.closest('.cd-go')){e.preventDefault();closeDone();}});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&done.classList.contains('on'))closeDone();});
    window.warmiaCloseDone=closeDone;
  })();

  var deck=root.querySelector('.wa-deck');
  if(deck){
    var cards=deck.children,dotsWrap=root.querySelector('.wa-dots');
    if(dotsWrap){
      for(var i=0;i<cards.length;i++){var d=document.createElement('i');if(i===0)d.className='on';dotsWrap.appendChild(d);}
      deck.addEventListener('scroll',function(){var idx=Math.round(deck.scrollLeft/(cards[0].offsetWidth+14));var ds=dotsWrap.children;for(var j=0;j<ds.length;j++)ds[j].className=(j===idx)?'on':'';},{passive:true});
    }
  }

  var stickyBar=root.querySelector('.stickybar-js');
  if(stickyBar){window.addEventListener('scroll',function(){stickyBar.classList.toggle('on',window.scrollY>560);},{passive:true});}

  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){for(var i=0;i<es.length;i++)if(es[i].isIntersecting){es[i].target.classList.add('in');io.unobserve(es[i].target);}},{threshold:.12});
    var r=root.querySelectorAll('.rv');for(var i=0;i<r.length;i++)io.observe(r[i]);
  }else{
    var r2=root.querySelectorAll('.rv');for(var i=0;i<r2.length;i++)r2[i].classList.add('in');
  }

  var qs=root.querySelectorAll('.faq-q');
  for(var i=0;i<qs.length;i++){(function(q){q.addEventListener('click',function(){
    var f=q.parentElement,a=f.querySelector('.faq-a'),o=f.classList.contains('open');
    var all=root.querySelectorAll('.faq');for(var j=0;j<all.length;j++){all[j].classList.remove('open');all[j].querySelector('.faq-a').style.maxHeight=null;}
    if(!o){f.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
  });})(qs[i]);}
}

document.addEventListener('DOMContentLoaded',function(){
  if(new URLSearchParams(window.location.search).get('warmia_thanks')==='1'){
    var page=document.getElementById('warmiaThanks'),info={};
    try{info=JSON.parse(sessionStorage.getItem('warmia_thanks')||'{}');sessionStorage.removeItem('warmia_thanks');}catch(_e){}
    if(page){
      var order=String(info.order||'').replace(/^#/,'');
      page.innerHTML='<div class="thanks-card"><div class="thanks-check">✓</div><h1>شكراً على طلبك 🤍</h1><p>تسجل الطلب ديالك بنجاح. غادي نعيطو ليك قريباً باش نأكدوه معاك.</p><div class="thanks-order"><b>'+(order?('الطلب رقم #'+order):'الطلب تسجل بنجاح')+'</b><span>الدفع عند الاستلام · التوصيل لجميع المدن</span></div><a class="thanks-home" href="'+window.location.pathname+'">الرجوع للمتجر</a></div>';
      page.hidden=false;page.classList.add('on');document.body.style.overflow='hidden';
    }
    return;
  }
  var roots=document.querySelectorAll('[data-warmia-id]');
  for(var i=0;i<roots.length;i++)warmiaInitSection(roots[i]);
});
